//Hooks
import { get } from 'svelte/store';
// Formating
import { format } from 'svelte-i18n';
//Helpers
import { addDate, dateFormat } from '../../date_helper';
import { checkForStatisticError, getChartSensorName } from '../core/chart_helper';
import { mathEpsilon } from '../../utilities';
import { app, os } from 'src/stores';
//Types
import type { ChartDataInterface } from 'src/types/Chart';

export function generateCSVStatistic(
	statsData: ChartDataInterface,
	filename: string,
	date: { from: Date; to: Date },
) {
	filename =
		`${filename || ''}_${statsData.name}_${statsData?.sensorID ? getChartSensorName(statsData) + '_' : ''}` +
		`${dateFormat(date.from, 'd_m_Y_H') + 'h__' + dateFormat(addDate(date.to, 's'), 'd_m_Y_H') + 'h'}`;
	filename = `${filename.replace(/([^a-zа-я\d_]+)/gi, '_')}.csv`.toLowerCase();
	const newLine = '\n',
		sep = ',',
		$format = get(format);
	let csvContent = '';
	statsData.series.map((s) => {
		if (!s?.prevPeriod) {
			const name = s.name.replace(/_\d+$/, '').replace(/^reversed$/, 'total_returned');
			csvContent += ` ${$format('chart_legend_' + name, {
				default: s.name,
			})}${newLine}`;
			csvContent += ` ${$format('time', { default: 'Time' })}${sep} ${statsData.units} ${newLine} `;
			s.data.map((d) => {
				const value = checkForStatisticError(d.value) ? 'N/A' : mathEpsilon(d.value, 3);
				csvContent +=
					' ' + dateFormat(Number(d.dt), 'd/m/Y H:i', true) + ` ${sep} ${value} ${newLine} `;
			});
			csvContent += newLine;
		}
	});
	// Add BOM once at the beginning to ensure proper UTF-8 encoding for Excel
	csvContent = '\uFEFF' + csvContent;
	const a = document.createElement('a');
	if (get(app) && get(os) !== 'IOS') {
		const base64Csv = stringToUtf16LeBase64(csvContent);
		a.setAttribute('href', `data:text/csv;charset=utf-16le;base64,${base64Csv}`);
		a.setAttribute('download', filename);
		a.setAttribute('data-downloadurl', `text/csv:${filename}:data:text/csv;base64,${base64Csv}`);
		a.click();
	} else {
		a.setAttribute('target', '_blank');
		a.setAttribute('download', filename);
		const csv = new Blob([csvContent], { type: 'text/csv;charset=utf-8' }),
			windowURL = window.webkitURL || window.URL,
			url = windowURL.createObjectURL(csv);
		a.setAttribute('href', url);
		a.click();
		windowURL.revokeObjectURL(url);
	}
}

function stringToUtf16LeBase64(text: string): string {
	let binary = '';
	for (let i = 0; i < text.length; i++) {
		const code = text.charCodeAt(i);
		binary += String.fromCharCode(code & 0xff);
		binary += String.fromCharCode(code >> 8);
	}
	return btoa(binary);
}
